import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { BesichtigungsStatiServiceModule } from '..';
import { BesichtigungsStatiListComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    BesichtigungsStatiServiceModule
  ],
  declarations: [BesichtigungsStatiListComponent],
  exports: [BesichtigungsStatiListComponent],

})
export class BesichtigungsStatiListComponentModule { }
